export const imageURL = (path: string, url: string | undefined) => {
	return url ? 
		url?.startsWith('http://') || url?.startsWith('https://') ? 
			url : 
			`${path}${url}`
	: null
}